import { composeClassNames } from "@faedev/editor-utils";
import { CSSProperties } from "react";
import { Col, Row } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import constants from "src/constants";
import { sIntroduction } from "src/styles/sIntroduction.module.scss";
import { sPlaylistIntroduction } from "src/styles/sPlaylistIntroduction.module.scss";
import { ApiPlaylist } from "src/types/ApiPlaylist";
import Paragraph from "./Paragraph";
import ReadMore from "./ReadMore";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  data: ApiPlaylist;
};

function PlaylistIntroduction({ style, className, data }: Props) {
  return data ? (
    <Row
      style={style}
      className={composeClassNames([
        sIntroduction,
        sPlaylistIntroduction,
        className,
        "playlist-introduction",
      ])}
    >
      <Col className={"playlist-detail"}>
        {data.description && data.description.length > 0 ? (
          <ReadMore
            rowsVisible={constants.Text.descriptionRowsMedium}
            rowsCount={
              data.description.length / constants.Text.descriptionCharsPerRow
            }
          >
            <Paragraph size="xn">
              <ReactMarkdown>{data.description}</ReactMarkdown>
            </Paragraph>
          </ReadMore>
        ) : null}
      </Col>
    </Row>
  ) : null;
}

export default PlaylistIntroduction;
